import React, { useMemo, useState } from "react";
import ModuleHeader from "../components/ModuleHeader";
import AcceptanceChecklist from "../components/AcceptanceChecklist";
import StateMap from "../components/StateMap";
import ReviewPanel from "../components/ReviewPanel";

const allItems = Array.from({ length: 23 }, (_, i) => ({
  id: i + 1, name: ["Ramesh","Priya","Kumar","Sneha","Arjun"][i % 5],
  status: i % 2 ? "In Progress" : "Resolved"
}));

export default function PaginationFilters() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const size = 5;

  const filtered = useMemo(() =>
    allItems.filter(x => x.name.toLowerCase().includes(search.toLowerCase())), [search]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / size));
  const safePage = Math.min(page, totalPages);
  const rows = filtered.slice((safePage - 1) * size, safePage * size);

  return <div className="page">
    <ModuleHeader number="020" title="Pagination & Filter Query Handling"
      description="Prototype search/filter controls, query-state handling and reusable pagination behavior." />
    <div className="row g-3">
      <div className="col-lg-5">
        <AcceptanceChecklist items={[
          "Search/filter value is reflected in the request query.",
          "Changing a filter resets pagination to page one.",
          "Current page and total pages are visible.",
          "Previous/Next controls disable at boundaries.",
          "Empty filtered results have a clear empty state."
        ]} />
      </div>
      <div className="col-lg-7">
        <div className="content-card">
          <div className="section-title">Prototype — Conversations</div>
          <input className="form-control mb-3" placeholder="Search by user..." value={search}
            onChange={e => { setSearch(e.target.value); setPage(1); }} />
          {rows.length ? (
            <div className="table-responsive">
              <table className="table">
                <thead><tr><th>ID</th><th>User</th><th>Status</th></tr></thead>
                <tbody>{rows.map(x => <tr key={x.id}><td>#{x.id}</td><td>{x.name}</td><td>
                  <span className={`badge-soft ${x.status === "Resolved" ? "badge-success" : "badge-warning"}`}>{x.status}</span>
                </td></tr>)}</tbody>
              </table>
            </div>
          ) : <div className="alert alert-light small">No conversations found.</div>}
          <div className="d-flex justify-content-between align-items-center">
            <small className="text-muted">Page {safePage} of {totalPages} · {filtered.length} results</small>
            <ul className="pagination mb-0">
              <li className={`page-item ${safePage === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => setPage(p => Math.max(1, p - 1))}>Previous</button>
              </li>
              <li className="page-item active"><span className="page-link">{safePage}</span></li>
              <li className={`page-item ${safePage === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => setPage(p => Math.min(totalPages, p + 1))}>Next</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div className="mt-3">
      <StateMap states={[
        {label:"Default", detail:"Page 1", icon:"bi-list"},
        {label:"Filter", detail:"Query updated", icon:"bi-funnel"},
        {label:"Loading", detail:"Fetch page", icon:"bi-arrow-repeat"},
        {label:"Results", detail:"Render rows", icon:"bi-table"}
      ]} />
    </div>
    <div className="mt-3">
      <ReviewPanel
        components={["SearchInput", "FilterBar", "Pagination", "EmptyState"]}
        dependencies={["React useMemo", "Bootstrap Table", "Bootstrap Pagination", "fetch API"]}
        notes="Keep filter and pagination query state predictable so list screens can reuse the same component contract."
      />
    </div>
  </div>;
}
